import { Box, styled } from '@mui/material';

const StyGridTitleContainer = styled(Box, {
    name: 'StyGridTitleContainer',
})(({ theme }) => ({
    display: 'flex',
    gap: '2em',
    alignSelf: 'center',
    flex: 1,
    alignItems: 'center',
    color: theme.palette.primary.main,
}));

export default StyGridTitleContainer;
